import {Storage} from "./Storage";
import {LoaderControllerStorageData} from "../definitions/utils/loader/LoaderControllerStorageData";
import {CustomLoader} from "../elements/customLoader";

export namespace Loader {

    export class LoaderController {

        /**
         * Append request to show loader
         */
        public static appendRequest(): void {

            const location = window.location.href;
            let storageData : LoaderControllerStorageData = Storage.StorageController.getFromStorage('LoaderController');
            if (storageData && storageData.location === location) {
                storageData.running = storageData.running + 1;
            } else {
                storageData = { running: 1, location: location };
            }
            Storage.StorageController.saveToStorage('LoaderController', storageData);
            CustomLoader.UiHandler.showLoader();
        }

        /**
         * Remove request to possibly hide loader
         */
        public static removeRequest(): void {

            const location = window.location.href;
            let storageData : LoaderControllerStorageData = Storage.StorageController.getFromStorage('LoaderController');
            if (storageData && storageData.location === location) {
                storageData.running = storageData.running - 1;
            } else {
                storageData = { running: 0, location: location };
            }
            if (storageData.running < 0) { storageData.running = 0; }
            Storage.StorageController.saveToStorage('LoaderController', storageData);
            if (storageData.running === 0) {
                CustomLoader.UiHandler.hideLoader();
            }
        }
    }
}
